import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import styles from '../styles.scss'
import FontIcon from 'react-toolbox/lib/font_icon'
import { Box, Flex } from 'reflexbox'
import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'

class LoadingPage extends Component {
  loadingRenderer = () => {
    return (
      <Flex
      align='center'
      column
      auto
      styleName='flexContainer'
      >
        <div styleName='loadingContainer'>
          <ProgressBar/>
          <div styleName='infoElements'>
            <p styleName='infoText'>Updating Projects<span>.</span><span>.</span><span>.</span></p>
            <div styleName='timeInfoElement'> 
              <p>This may take a few seconds</p>
              <FontIcon
                styleName=''
                value='schedule'
              />
            </div>
          </div> 
        </div>
        <Box auto/>
      </Flex>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.loadingRenderer()}
      </React.Fragment>
    )
  }
}

export default CSSModules(LoadingPage, styles)
